import Nullstack from 'nullstack';
export default function IconArrowUpRhombus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-up-rhombus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v-13"
  }), "   ", Nullstack.element("path", {
    d: "M15 6l-3 -3l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z"
  }), " ");
}